import { useState } from 'react'

type Props = { text: string; className?: string; limit?: number }

// Instagram-style caption: shows a short preview, then a tappable "… more" to
// expand to the full caption (and "less" to collapse). Uses a <span> toggle (not
// a <button>) so it can live inside the post card's tap-to-open button without
// nesting buttons. A pure display helper — no data.
export default function CaptionText({ text, className, limit = 60 }: Props) {
  const [expanded, setExpanded] = useState(false)
  const clean = (text || '').trim()
  if (!clean) return null

  if (clean.length <= limit) return <p className={className}>{clean}</p>

  // Trim the preview at a word boundary near the limit
  let preview = clean.slice(0, limit)
  const lastSpace = preview.lastIndexOf(' ')
  if (lastSpace > 30) preview = preview.slice(0, lastSpace)
  preview = preview.replace(/[\s.,;:!-]+$/, '')

  const toggle = (e: React.MouseEvent) => { e.stopPropagation(); e.preventDefault(); setExpanded(v => !v) }

  return (
    <p className={className}>
      {expanded ? clean : preview}
      <span onClick={toggle} role="button" className="text-coffee-400 font-semibold cursor-pointer ml-1">
        {expanded ? ' less' : '… more'}
      </span>
    </p>
  )
}
